<template>
  <div class="Sign">
    <el-dialog :visible.sync="dialogVisible" width="400px">
      <div class="sign-menu">
        <p class="title">新账号注册</p>
        <el-form :rules="rules" ref="details" :model="details" >
          <el-form-item prop="userName">
            <el-input
              v-model="details.userName"
              placeholder="请输入电话号码"
              prefix-icon="el-icon-user"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="imageVerification">
            <el-row>
              <el-col :span="17">
                <el-input
                  v-model="details.imageVerification"
                  placeholder="请输入图形码"
                >
                </el-input>
              </el-col>
              <el-col :span="6">
                <img
                  style="width:93px;margin-top:2px;margin-left:4px"
                  :src="imgcode"
                  alt=""
                  @click="changeimgcode"
                />
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-row>
              <el-col :span="17">
                <el-input
                  v-model="details.telCode"
                  placeholder="请输入手机验证码"
                >
                </el-input>
              </el-col>
              <el-col :span="7">
                <el-button
                  v-show="show"
                  style="width: 96%;height: 41px;margin-left: 4px;font-size: 14px;"
                  @click="getcode(details)"
                  >获取验证码</el-button
                >
                <el-button
                  class="count"
                  v-show="!show"
                  style="width: 96%;margin-left: 4px"
                  >{{ times }} s
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="details.password"
              type="password"
              placeholder="请设置8位以上的数字和字母组合密码"
              prefix-icon="el-icon-lock"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="checkPass">
            <el-input
              type="password"
              v-model="details.checkPass"
              placeholder="请再次输入密码"
              prefix-icon="el-icon-lock"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <div class="btn-box">
          <p class="hint" @click="backLogin">已有网站账号？返回登录</p>
          <el-button class="sign" @click="submitForm('details')" >注册</el-button>
        </div>
      </div>
    </el-dialog>
    <UserLogin ref="UserLogin" />
  </div>
</template>

<script>
import UserLogin from './UserLogin.vue'
import { register, telVerification, login } from "../../utils/router/login.api";
export default {
  name: "Login",
  components: {
    UserLogin
  },
  data() {
    var validateMobilePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("手机号不可为空"));
      } else {
        if (value !== "") {
          var reg = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
          if (!reg.test(value)) {
            callback(new Error("请输入有效的手机号码"));
          }
        }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (/^[0-9a-zA-Z]{8,}$/.test(value) && isNaN(value)) {
        if (this.details.checkPass !== "") {
          this.$refs.details.validateField("checkPass");
        }
        callback();
      } else {
        callback(new Error("必须是8位以上字母和数字组合"));
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.details.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      show: true,
      times: "",
      timer: null,
      details: {
        userName: "",
        imageVerification: "",
        telCode: "",
        password: "",
        checkPass: "",
        typeId: this.$store.state.typeId,
      },
      rules: {
        userName: [{ validator: validateMobilePhone, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        imageVerification: [{required: true, message: '请输入'},],
      },
      dialogVisible: false,
      imgcode: "/portal/reader/imageVerification",
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.regBtn(this.details)
        } else {
          this.$message('验证未通过');
          return false;
        }
      });
    },
    regBtn(row) {
      register({
        checkPass: row.checkPass,
        userName: row.userName,
        typeId: this.typeId,
        password: this.$md5(row.password),
        imageVerification: row.imageVerification,
        telCode: row.telCode,
        typeId: this.$store.state.typeId,
      }).then((res) => {
        if (res && res.data.code === 200) {
          this.$alert("注册成功", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.dialogVisible = false;
            },
          });
        } else {
          this.$alert(res.data.message);
        }
      });
    },
    changeimgcode() {
      var num = Math.ceil(Math.random() * 10);
      this.imgcode = "/portal/reader/imageVerification?" + num;
    },
    getcode(row) {
      telVerification({
        tel: row.userName,
        imageVerification: row.imageVerification,
      }).then((res) => {
        if (res.data.code === 200) {
          const TIME_TIMES = 60;
          if (!this.timer) {
            this.times = TIME_TIMES;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.times > 0 && this.times <= TIME_TIMES) {
                this.times--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        } else {
          this.$alert(res.data.message);
        }
      });
    },
    openDialog() {
      this.dialogVisible = true;
      this.loginForm = Object.assign({});
    },
    backLogin() {
      this.dialogVisible = false
      this.$refs.UserLogin.openDialog(false);
    },
  },
  created(){
    this.changeimgcode()
  }
};
</script>

<style lang="less" scoped>
.Sign {
  .sign-menu {
    width: 334px;
    height: 328px;
    margin: auto;
    .title {
      font-weight: bold;
      font-size: 24px;
      margin-bottom: 34px;
      text-align: center;
    }
    .btn-box {
      display: flex;
      justify-content: space-between;
      .el-button {
        width: 166px;
        height: 44px;
        border-radius: 6px;
        background-color: #654719;
        color: #fff;
        margin-left: 32px;
      }
      p {
        width: 106px;
        font-size: 14px;
        line-height: 26px;
        cursor: pointer;
      }
    }
  }
}

/deep/.el-input--small .el-input__inner {
  height: 44px;
  border: 1px solid #654719;
}
/deep/.el-dialog {
  height: 520px;
  position: fixed;
  top: 0;
  right: 10%;
}
</style>
